import React from "react";

export default function DateInput({
  label = "Data",
  name,
  value,
  onChange,
  disabled = false,
  width = "180px",       // puoi passare "100%" o "220px"
  minWidth = "150px",
  required = false,
}) {
  return (
    <label style={{ display: "grid", gap: 6 }}>
      <span style={{ color: "white" }}>
        {label} {required ? "*" : ""}
      </span>

      <input
        type="date"
        name={name}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        style={{
          width,
          minWidth,
          padding: "8px 12px",
          borderRadius: 8,

          border: "1px solid rgba(255,255,255,0.15)",
          background: "linear-gradient(180deg, #1f2937 0%, #111827 100%)",

          color: "white",
          outline: "none",

          boxShadow: "inset 0 1px 2px rgba(0,0,0,0.4)",
          fontFamily: "inherit",
          fontSize: 14,

          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.65 : 1,
        }}
      />
    </label>
  );
}